module.exports = __webpack_public_path__ + "img/door.2acca091.svg";